// All the middlewares
// store is a state warehouse which
import { createStore, applyMiddleware } from "redux"
//useful for the debug
import logger from "redux-logger"
import { persistStore, persistReducer } from "redux-persist"
import rootReducer from "./rootReducer"

//Yuan: test the storage
import storage from "redux-persist/lib/storage"
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2"

// an array of middlewares. It is more scalable in this way
const middleWares = []

//if we are in the development environment, then use logger.
if (process.env.NODE_ENV === "development") {
  middleWares.push(logger)
}

const persistConfig = {
  key: "root",
  storage: storage,
  stateReconciler: autoMergeLevel2, // check 'Merge Process'
}

const myPersistReducer = persistReducer(persistConfig, rootReducer)

// apply the middlewares
const initalState = { user: null }
export const store = createStore(
  myPersistReducer,
  initalState,
  applyMiddleware(...middleWares)
)
//creating the persisited version of our store.
export const persistor = persistStore(store)

export default { store, persistor }
